import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-refund-reason-dialog',
  templateUrl: './refund-reason-dialog.component.html',
  styleUrls: ['./refund-reason-dialog.component.css']
})

export class RefundReasonDialogComponent implements OnInit {
  refundForm: FormGroup;
  orderDetail: any[] = [];
  refundedQuantities: { [productId: string]: number } = {};
  filteredOrderDetail: any[] = [];
  selectedProductDetails: any[] = [];
  presetReasons: string[] = [
    'Product not dispensed',
    'Charged but item not received',
    'Expired or bad quality product',
    'Product stuck in machine',
    'Payment failed but money deducted',
    'Machine not responding'
  ];

  selectedPresetReason: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<RefundReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { orderId: any; orderDetail: any[]; refundedQuantities: { [productId: string]: number } },
    private fb: FormBuilder
  ) {
    this.orderDetail = data.orderDetail || [];
    this.refundedQuantities = data.refundedQuantities || {};
  }

  ngOnInit(): void {
    this.filteredOrderDetail = this.orderDetail.filter(p => {
      const alreadyRefunded = this.refundedQuantities[p.id] || 0;
      return p.num - alreadyRefunded > 0;
    });

    const productControls = this.filteredOrderDetail.map(product => {
      const refunded = this.refundedQuantities[product.id] || 0;
      const maxQty = product.num - refunded;

      return this.fb.group({
        selected: [false],
        refundQty: [1, [Validators.min(1), Validators.max(maxQty)]]
      });
    });

    this.refundForm = this.fb.group({
      reason: [''],
      products: this.fb.array(productControls)
    });

    this.updateSelectedProductDetails();
  }

  get productsFormArray() {
    return this.refundForm.get('products') as FormArray;
  }

  getRefundAmount(product: any, i: number): number {
    const control = this.productsFormArray.at(i);
    const qty = control.get('refundQty')?.value || 0;
    return qty * product.detailPrice;
  }

  blockTyping(event: KeyboardEvent) {
    const allowedKeys = ['ArrowUp', 'ArrowDown', 'Tab', 'Backspace'];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  get selectedProductsWithQty() {
    return this.filteredOrderDetail.map((product, i) => {
      const control = this.productsFormArray.at(i);
      return {
        ...product,
        refundQty: control.get('refundQty')?.value || 0,
        selected: control.get('selected')?.value || false
      };
    }).filter(p => p.selected && p.refundQty > 0);
  }

  updateSelectedProductDetails() {
    this.selectedProductDetails = this.selectedProductsWithQty;
  }
   onCancel(): void {
     this.dialogRef.close();
   }

 onPresetReasonChange() {
  if (this.selectedPresetReason !== 'other') {
    this.refundForm.get('reason')?.setValue('');
  }
}
triggerRevalidation() {
  this.refundForm.get('reason')?.updateValueAndValidity();
}

isFormValid(): boolean {
  const reasonValue = this.refundForm.get('reason')?.value?.trim();
  const isOtherSelected = this.selectedPresetReason === 'other';
  const hasTypedReason = reasonValue && reasonValue.length > 0;
  const hasPresetReason = !!this.selectedPresetReason && this.selectedPresetReason !== 'other';
  const hasSelectedProduct = this.selectedProductDetails.length > 0;

  return hasSelectedProduct && (hasPresetReason || (isOtherSelected && hasTypedReason));
}

  onSubmit(): void {
    const typedReason = this.refundForm.get('reason')?.value?.trim();
    const selectedProductObjects = this.selectedProductsWithQty;

    if (!selectedProductObjects.length) return;

    let reasonToSend = '';
    if (this.selectedPresetReason === 'other') {
      if (!typedReason) return; 
      reasonToSend = typedReason;
    } else if (this.selectedPresetReason) {
      reasonToSend = this.selectedPresetReason;
    } else {
      return; 
    }

    const summary = selectedProductObjects.map(p =>
      `${p.name} — ${p.refundQty} * ${p.detailPrice} = ${(p.refundQty * p.detailPrice).toFixed(2)} kr`
    ).join('\n');

    const fullReasonMessage = `Refunded Products:\n${summary}\n\nReason:\n${reasonToSend}`;

    this.dialogRef.close({
      reason: fullReasonMessage,
      selectedProducts: selectedProductObjects.map(p => ({ id: p.id, refundQty: p.refundQty }))
    });
  }
}
